/* ============================================================
   SC Reviews — "Read more" + pop-out
   ------------------------------------------------------------
   Review cards (.sc-review) are a fixed height and clamp their
   body to a few lines. This script:
     1. adds a "Read more" button ONLY to cards whose body is
        actually truncated (measured after fonts load), and
     2. opens a pop-out with the full review on click.
   Works for any .sc-review on the page (the homepage Customer
   Wall and the product-page SC Reviews both use the same card),
   and reads everything from the card's own DOM, so there is no
   separate data source to keep in sync.

   The horizontal scroll arrows are handled by the shared
   carousel click-handler in sc-components.js; this file does
   not touch them.
   ============================================================ */
(function () {
  'use strict';

  var modal = null;

  function buildModal() {
    var root = document.createElement('div');
    root.className = 'sc-review-modal';
    root.innerHTML =
      '<div class="sc-review-modal-scrim" data-sc-review-close></div>' +
      '<div class="sc-review-modal-panel" role="dialog" aria-modal="true" aria-label="Customer review">' +
        '<button class="sc-review-modal-close" type="button" aria-label="Close" data-sc-review-close>&times;</button>' +
        '<div class="sc-review-stars" data-mstars></div>' +
        '<h3 class="sc-review-modal-headline" data-mhead></h3>' +
        '<p class="sc-review-modal-body" data-mbody></p>' +
        '<div class="sc-review-modal-meta" data-mmeta></div>' +
      '</div>';
    document.body.appendChild(root);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sc-review-close]')) closeModal();
    });
    return {
      root: root,
      stars: root.querySelector('[data-mstars]'),
      head: root.querySelector('[data-mhead]'),
      body: root.querySelector('[data-mbody]'),
      meta: root.querySelector('[data-mmeta]')
    };
  }

  function openModal(card) {
    if (!modal) modal = buildModal();
    var stars = card.querySelector('.sc-review-stars');
    var head = card.querySelector('.sc-review-headline');
    var body = card.querySelector('.sc-review-body');
    var meta = card.querySelector('.sc-review-meta');

    modal.stars.innerHTML = stars ? stars.innerHTML : '';
    if (head && head.textContent.trim() !== '') {
      modal.head.textContent = head.textContent;
      modal.head.style.display = '';
    } else {
      modal.head.style.display = 'none';
    }
    /* The body text is fully present in the DOM; the clamp is only
       visual, so textContent gives the complete review. */
    modal.body.textContent = body ? body.textContent.trim() : '';
    modal.meta.innerHTML = meta ? meta.innerHTML : '';

    document.body.classList.add('sc-modal-open');
    modal.root.classList.add('is-visible');
  }

  function closeModal() {
    if (!modal) return;
    modal.root.classList.remove('is-visible');
    document.body.classList.remove('sc-modal-open');
  }

  function scan() {
    var bodies = document.querySelectorAll('.sc-review-body');
    Array.prototype.forEach.call(bodies, function (body) {
      var card = body.closest('.sc-review');
      if (!card) return;
      var existing = card.querySelector('.sc-review-more');
      var truncated = body.scrollHeight > body.clientHeight + 2;
      if (truncated && !existing) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sc-review-more';
        btn.textContent = 'Read more';
        var meta = card.querySelector('.sc-review-meta');
        if (meta) card.insertBefore(btn, meta);
        else card.appendChild(btn);
      } else if (!truncated && existing) {
        existing.remove();
      }
    });
  }

  /* Open via delegation so it also covers any cards added later. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sc-review-more');
    if (!btn) return;
    var card = btn.closest('.sc-review');
    if (card) openModal(card);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeModal();
  });

  /* Toggle is-at-start / is-at-end / is-not-scrollable on each carousel wrap so
     the CSS can hide the prev arrow at the far left, the next arrow at the far
     right, and BOTH arrows when the row isn't wide enough to scroll at all.
     Covers the review carousels (.sc-customer-wall-wrap) and the homepage
     collection grid (.sc-carousel-wrap). */
  function initCarouselEdges() {
    var wraps = document.querySelectorAll('.sc-customer-wall-wrap, .sc-carousel-wrap');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var track = wrap.querySelector('[data-sc-carousel]');
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        wrap.classList.toggle('is-not-scrollable', max <= 1);
        wrap.classList.toggle('is-at-start', x <= 1);
        wrap.classList.toggle('is-at-end', x >= max - 1);
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      /* Images can change the row width after first paint, so recheck on load. */
      window.addEventListener('load', update);
      update();
    });
  }

  function init() {
    scan();
    initCarouselEdges();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(scan, 150);
    });
  }

  function start() {
    /* Measure after fonts load, since text height drives the
       truncation test. Run an immediate pass too in case fonts
       are already cached. */
    scan();
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(init);
    } else {
      window.addEventListener('load', init);
      init();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
